"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * See https://developer.mozilla.org/en-US/docs/Web/API/FileReader for details of different data type
 */
var ContentReaderDataType;
(function (ContentReaderDataType) {
    ContentReaderDataType[ContentReaderDataType["Text"] = 0] = "Text";
    ContentReaderDataType[ContentReaderDataType["EncodedData"] = 1] = "EncodedData";
})(ContentReaderDataType = exports.ContentReaderDataType || (exports.ContentReaderDataType = {}));
exports.FormContext = React.createContext({});
exports.FormContextConsumer = exports.FormContext.Consumer;
exports.FormContextProvider = exports.FormContext.Provider;
exports.FieldContext = React.createContext({});
exports.FieldContextProvider = exports.FieldContext.Provider;
exports.FieldContextConsumer = exports.FieldContext.Consumer;
//# sourceMappingURL=types.js.map